<template>
  <div class="sm:hidden">
    <button
      class="icon-button flex items-center justify-center h-20 pl-2"
      @click="showMenu = true"
    >
      <img
        src="@/assets/svg/icon_48px_hamburgerMenu.svg"
        alt="show menu"
      >
    </button>

    <div
      v-if="showMenu"
      class="fixed inset-0 bg-white z-50"
    >
      <div class="flex justify-between items-center p-4">
        <LogoIcon />
        <button @click="showMenu = false">
          <img
            src="@/assets/svg/icon_48px_close.svg"
            alt="close menu"
          >
        </button>
      </div>
      <div class="flex flex-col gap-2 mt-5">
        <router-link
          :to="{ name: 'UserInfoPage' }"
          :class="{ 'bg-gray-200': activeItem === 'accountInfo' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.account_info') }}
          </div>
        </router-link>
        <router-link
          :class="{ 'bg-gray-200': activeItem === 'Passkey' }"
          :to="{ name: 'PasskeyPage' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.passkey') }}
          </div>
        </router-link>
        <router-link
          v-if="user && user.login_method === 'password' && user.passwordless_status !== 'completed'"
          :to="{ name: 'TwoFactorAuthPage' }"
          :class="{ 'bg-gray-200': activeItem === 'two-factor-auth' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.two_factor_auth') }}
          </div>
        </router-link>
        <router-link
          :class="{ 'bg-gray-200': activeItem === 'loginHistory' }"
          :to="{ name: 'UserLoginHistoryPage' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.sign_in_history') }}
          </div>
        </router-link>
        <router-link
          :class="{ 'bg-gray-200': activeItem === 'notification' }"
          :to="{ name: 'UserNotificationPage' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.notifications') }}
          </div>
        </router-link>
        <router-link
          :class="{ 'bg-gray-200': activeItem === 'subscription' }"
          :to="{ name: 'EmailSubscriptionPage' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.subscriptions') }}
          </div>
        </router-link>
        <router-link
          v-if="isStaffVerified"
          :to="{ name: 'ManagementPage' }"
          :class="{ 'bg-gray-200': activeItem === 'management' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.management') }}
          </div>
        </router-link>
        <router-link
          v-if="isStaffVerified"
          :to="{ name: 'OAuthManagementPage' }"
          :class="{ 'bg-gray-200': activeItem === 'oauth-management' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.oauth_management') }}
          </div>
        </router-link>
        <router-link
          v-if="user && user.entra_id_eligible"
          :to="{ name: 'EntraIdConfigPage' }"
          :class="{ 'bg-gray-200': activeItem === 'entra' }"
          class="menu-item"
        >
          <div class="label">
            {{ $t('messages.menu.entra') }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LogoIcon from './LogoIcon.vue';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PopupUserMenu',
  components: {
    LogoIcon
  },
  props: {
    user: Object,
    activeItem: String
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    isStaffVerified() {
      return useAuthStore().is_staff_verified;
    }
  },
}
</script>

<style scoped>
.icon-button {
    /* Style your button icon here */
}

.logo {
    /* Logo styles */
}

.close-button {
    /* Style your close button here */
}

.menu-item {
    /* Common styles for menu items */
    cursor: pointer;
    padding: 0.75rem;
    border-radius: 0.5rem;
    transition: background-color 0.2s ease-out;
}

.menu-item:hover {
    background-color: #f0f0f0;
}

.label {
    /* Style your label text here */
}
</style>